import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=5397873a&lang=pug&"
import script from "./Cities.vue?vue&type=script&lang=ts&"
export * from "./Cities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports